import { render, staticRenderFns } from "./indexYouMayLike.vue?vue&type=template&id=4f01bca6&scoped=true&"
import script from "./indexYouMayLike.vue?vue&type=script&lang=js&"
export * from "./indexYouMayLike.vue?vue&type=script&lang=js&"
import style0 from "./indexYouMayLike.vue?vue&type=style&index=0&id=4f01bca6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f01bca6",
  null
  
)

export default component.exports